export default `
query getProjectContent{
    allSimpleTexts(filter: {useDictionary: {eq: "true"}}, first: "100") {
        text
        entryTitle
      }
}
`;
